import { Button, Icon } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useSendGiftCardEmail } from '@hero/services/order-service/hook';
import { useNotification } from '@hero/store/hooks';

function EGiftButton({ code, email }) {
  const { showNotification, showSuccess } = useNotification();
  const { t } = useTranslation();
  const { mutateAsync: sendGiftCardEmail } = useSendGiftCardEmail({
    onSuccess: () => {
      showSuccess({
        message: t('emailSuccessfullySent', {
          recipientEmailAddress: email
        }),
        type: 'toast'
      });
    }
  });

  return (
    <Button
      startIcon={<Icon name="email" />}
      onClick={() => {
        showNotification({
          popupStyle: {
            maxWidth: '500px'
          },
          header: t('sendEGiftCardEmail'),
          title: t('areYouSureEmailEGiftCard', {
            recipientEmailAddress: email
          }),
          message: t('wellEmailThemEGiftCard'),
          notificationImage: <Icon name="email" size="xxl" color="var(--color-fg-default)" />,
          secondaryButtonProps: { children: t('cancel') },
          primaryButtonProps: { children: t('send') },
          onSubmit: () => {
            sendGiftCardEmail(code);
          }
        });
      }}
      variant="link"
      color="primary"
    >
      {t('sendEGiftCardEmail')}
    </Button>
  );
}

export { EGiftButton };
